import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { VideoSearchResult } from '../../model/video-search-result.model';

@Component({
  selector: 'app-video-metadata',
  templateUrl: 'video-metadata.component.html',
  styleUrls: ['video-metadata.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class VideoMetadataComponent implements OnInit {

  @Input() video: VideoSearchResult = null;


  constructor() { }

  ngOnInit() {
  }

  isLoading(): boolean {
    return !this.video;
  }

  getFormatedVideoDuration(): string {

    let videoDurationInSeconds = this.video?.duration_in_seconds;
    let seconds = 0;
    let minutes = 0;
    let hours = 0;
    let durationOutputString = '';


    if (!videoDurationInSeconds) {
      return '0:00';
    }

    videoDurationInSeconds = Math.floor(videoDurationInSeconds);

    // Convert the duration from seconds to a human-readable format
    minutes = Math.floor(videoDurationInSeconds / 60);
    seconds = videoDurationInSeconds % 60;
    hours = Math.floor(minutes / 60);
    minutes = minutes % 60;

    if (hours > 0) {
      durationOutputString += hours + ':';
    }

    if (minutes < 10) {
      durationOutputString += '0';
    }

    durationOutputString += minutes + ':';

    if (seconds < 10) {
      durationOutputString += '0';
    }

    durationOutputString += seconds;

    return durationOutputString;
  }

}
